import {mapCallbackLogsToEvents} from './mappers/fromCallbackLogs'
import {mapCommandLogsToEvents} from './mappers/fromCommandLogs'
import {mapConnectionLogsToEvents} from './mappers/fromConnectionLogs'
import {mapMishapsToEvents} from './mappers/fromMishaps'
import {mapPrintJobsToEvents} from './mappers/fromPrintJobs'
import {sortEventsAscending} from './time'
import {PrintStoryDoc, PrintStoryEvent} from './types'

export const buildPrinterStoryEvents = ({
  printJobs = [],
  mishaps = [],
  callbackLogs = [],
  commandLogs = [],
  connectionLogs = [],
  includeConnectionLogs = true,
}: {
  printJobs?: PrintStoryDoc[]
  mishaps?: PrintStoryDoc[]
  callbackLogs?: PrintStoryDoc[]
  commandLogs?: PrintStoryDoc[]
  connectionLogs?: PrintStoryDoc[]
  includeConnectionLogs?: boolean
}): PrintStoryEvent[] => {
  const events: PrintStoryEvent[] = [
    ...mapMishapsToEvents(mishaps),
    ...mapPrintJobsToEvents(printJobs),
    ...mapCallbackLogsToEvents(callbackLogs),
    ...mapCommandLogsToEvents(commandLogs),
  ]

  if (includeConnectionLogs) {
    events.push(...mapConnectionLogsToEvents(connectionLogs))
  }

  return sortEventsAscending(events)
}
